import type { CSSProperties } from 'react';

export interface SkeletonProps {
  readonly className?: string;
  readonly style?: CSSProperties;
}

export function Skeleton({ className = '', style }: SkeletonProps): JSX.Element {
  return (
    <div
      role="presentation"
      className={`relative overflow-hidden rounded-md bg-card-2 ${className}`}
      style={style}
    >
      <div
        className="absolute inset-0 animate-shimmer"
        style={{
          background:
            'linear-gradient(90deg, transparent 0%, rgba(255,255,255,0.04) 50%, transparent 100%)',
          backgroundSize: '800px 100%',
        }}
      />
    </div>
  );
}
